import React from "react";

import styles from "./content.module.scss";

interface IProps {}

const Content: React.FC<IProps> = (props) => {
  return (
    <div className={styles.content}>
      {props.children}
    </div>
  ) 
};

export default Content;